
import axios from "axios";
import { useEffect, useState }  from "react";

interface Article {
  id: number;
  name: string;
  image: string;
  categorie?: string | { "@id"?: string; id?: number };
  categories?: Array<string | { "@id"?: string; id?: number }>;
}

const getCategoryId = (categoryUrl: string) => categoryUrl.split("/").filter(Boolean).pop();

const categoryMatches = (
  category: Article["categorie"] | NonNullable<Article["categories"]>[number],
  categorieUrl: string
) => {
  if (!category) return false;

  if (typeof category === "string") {
    return category === categorieUrl || getCategoryId(category) === getCategoryId(categorieUrl);
  }

  if (category["@id"]) {
    return category["@id"] === categorieUrl || getCategoryId(category["@id"]) === getCategoryId(categorieUrl);
  }

  return String(category.id) === getCategoryId(categorieUrl);
};

const FetchArticles=(url: string, categorieUrl?: string)=> {
  const [articles, setArticles] = useState<Article[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        const response = await axios.get(url);
        const apiArticles = response.data["hydra:member"] || response.data.member || response.data || [];
        const filteredArticles = apiArticles.filter((article: Article) => {
          if (!categorieUrl) return true;

          if (article.categories?.some((category) => categoryMatches(category, categorieUrl))) {
            return true;
          }

          return categoryMatches(article.categorie, categorieUrl);
        });
        setArticles(filteredArticles);
      } catch (error) {
        console.error('Erreur lors de la récupération des articles :', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [url, categorieUrl]); // Effectuer le fetch chaque fois que l'URL ou la catégorie change

  return { articles, isLoading };
}

export default FetchArticles
